import { useCallback, useEffect, useState } from "react";
import {
  addRecentSearch,
  getRecentSearches,
  RECENT_SEARCHES_KEY
} from "@/utils/recentSearches";

export interface UseRecentSearchesReturn {
  recentSearches: string[];
  addRecentSearch: (term: string) => void;
}

/**
 * Exposes the user's recent free-text searches with a setter that persists to
 * localStorage. Stays in sync across tabs via the `storage` event.
 */
export function useRecentSearches(): UseRecentSearchesReturn {
  const [recentSearches, setRecentSearches] = useState<string[]>(() =>
    getRecentSearches()
  );

  const add = useCallback((term: string) => {
    setRecentSearches(addRecentSearch(term));
  }, []);

  useEffect(() => {
    const handleStorage = (event: StorageEvent) => {
      if (event.key === RECENT_SEARCHES_KEY) {
        setRecentSearches(getRecentSearches());
      }
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  return { recentSearches, addRecentSearch: add };
}
